export const isEmbeddedSelector = ({ gdpr }) => Boolean(gdpr.isEmbedded)
